const getWebBaseUrl = (): string => {
  const env = process.env.EXPO_PUBLIC_APP_ENV;
  if (env === 'production') return 'https://flavrly.app';
  if (env === 'preview') return 'https://preview.flavrly.app';
  return 'http://localhost:8081';
};

export const getProfileShareUrl = (username: string): string => {
  const normalized = username.startsWith('@') ? username.slice(1) : username;
  return `${getWebBaseUrl()}/profile/${normalized}`;
};
